import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { uiRouteAllowed } from "@greg-chick/shared";
import { classMode, setClassMode } from "../lib/classMode";
import { ROUTES } from "../lib/routes";
import { useUiFeatures } from "../lib/uiFeaturesApi";

/**
 * 📚 **수업 중이라는 표시** — 그리고 끄는 길.
 *
 * ## 🔴 조용히 숨기면 안 된다
 * 수업 모드는 굿즈·커뮤니티·이벤트를 화면에서 뺀다. 그런데 **아무 표시도 없으면**
 * 나중에 그 태블릿을 쓴 사람은 「굿즈가 왜 없지」를 겪고, 아무도 이유를 모른다 —
 * 이 저장소가 거듭 겪은 「조용히 어긋남」이 딱 그 모양이다.
 *
 * 그래서 **켜져 있다고 말하고, 누르면 끌 수 있게** 한다.
 *
 * ## 막힌 곳으로 가면 되돌린다
 * 숨긴 화면 주소로 들어오면(북마크·이전 기록) 첫 화면으로 돌려보낸다.
 * 빈 화면을 보여 주는 것보다 낫다.
 *
 * 🔴 **수업 중일 때만 막는 게 아니다.** 운영자가 행사장용으로 굿즈를 껐다면 수업 모드가
 * 아니어도 그 주소는 막혀야 한다 — 메뉴만 감추고 주소는 열려 있으면 「숨겼는데 열린다」가 된다.
 * 판정은 `uiRouteAllowed` 한 곳(메뉴를 감추는 것과 **같은 함수**).
 */
export function ClassModeBadge() {
  const [on, setOn] = useState(false);
  const loc = useLocation();
  const navigate = useNavigate();
  const feat = useUiFeatures();

  useEffect(() => {
    setOn(classMode());
  }, [loc.search]);

  useEffect(() => {
    // 설정이 아직 안 왔으면 빈 것 = 다 열림. 늦게 와도 그때 막힌다(불변식 3의 폴백)
    if (uiRouteAllowed(loc.pathname, feat, on)) return;
    navigate(ROUTES.landing, { replace: true });
  }, [on, feat, loc.pathname, navigate]);

  if (!on) return null;

  return (
    <button
      type="button"
      className="classbadge"
      title="수업 중이라 굿즈·커뮤니티를 숨기고 있어요. 누르면 꺼져요"
      onClick={() => {
        if (!window.confirm("수업 모드를 끌까요?\n\n굿즈·커뮤니티·이벤트가 다시 보여요.")) return;
        setClassMode(false);
        setOn(false);
      }}
    >
      📚 수업 중
    </button>
  );
}
